// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2H7ez","question":"Question_question__Eo63Y","description":"Question_description__2KhY9"};